"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultContainerComponent = ResultContainerComponent;
const React = __importStar(require("react"));
// import * as Actions from "./actions";
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const DateHelper = __importStar(require("@genesys/shared/lib/date-helper"));
const clipboard = __importStar(require("@genesys/client-core/lib/browsertools/clipboard"));
// import * as UserProfile from "@genesys/client-core/lib/user-profile";
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const Exporter = __importStar(require("@genesys/client-core/lib/exporter"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const moisture_load_status_1 = require("@genesys/shared/lib/enums/moisture-load-status");
const pagination_1 = require("@genesys/client-core/lib/pagination");
const searchQueryGQL = (0, graphql_tag_1.default) `
  query MLCUsageStatisticsResultQuery($filter: MlcUsageSearchFilterInputType!) {
    user {
      mlcUsageSearch(filter: $filter) {
        id
        results {
          id
          status
          userName
          date
          name
          isDeleted
          lastUsage
          mLCItemsCount
          connectedGno
          mNoString
        }
      }
    }
  }
`;
function ResultContainerComponent(props) {
    const getFilterGroupSelection = (filterGroup) => {
        return props.searchSelections.filterOptions.find(x => x.type === filterGroup);
    };
    return (React.createElement(Contexts.UserProfileContext.Consumer, null, userProfile => (React.createElement(GraphQLQuery.QueryUserSimple, { variables: {
            filter: {
                dateFilterGroup: {
                    enabled: getFilterGroupSelection("date").useFilter,
                    groupBy: getFilterGroupSelection("date").groupBy,
                    selectedStartDateStringified: getFilterGroupSelection("date").selectedStartDateStringified,
                    selectedEndDateStringified: getFilterGroupSelection("date").selectedEndDateStringified
                },
                deletedFilterGroup: {
                    enabled: getFilterGroupSelection("deleted").useFilter,
                    groupBy: getFilterGroupSelection("deleted").groupBy,
                    selectedDeletedOptions: getFilterGroupSelection("deleted").selectedDeletedOptions
                },
                statusFilterGroup: {
                    enabled: getFilterGroupSelection("status").useFilter,
                    groupBy: getFilterGroupSelection("status").groupBy,
                    selectedStatus: getFilterGroupSelection("status").selectedStatus
                },
                usersFilterGroup: {
                    enabled: getFilterGroupSelection("users").useFilter,
                    groupBy: getFilterGroupSelection("users").groupBy,
                    selectedUsers: getFilterGroupSelection("users").selectedUsers
                },
                includeMno: props.searchSelections.includeMno
            }
        }, query: searchQueryGQL }, result => {
        const results = parseResult(result, userProfile.locale, props.genesysNumberPrefixes);
        return (React.createElement("div", null,
            React.createElement(ActionButtons, { results: results }),
            React.createElement(ResultTable, Object.assign({ results: results }, props))));
    }))));
}
function ActionButtons({ results }) {
    const copyCallback = () => {
        const text = "Status\tDate\tUser\tDeleted\tCount\tLast usage\tName\tMno\tConnected Gno" +
            results.reduce((a1, r) => a1 +
                "\r\n" +
                (r.status +
                    "\t" +
                    r.date +
                    "\t" +
                    r.user +
                    "\t" +
                    r.deleted +
                    "\t" +
                    r.date +
                    "\t" +
                    r.count +
                    "\t" +
                    r.lastUsed +
                    "\t" +
                    r.name +
                    "\t" +
                    r.mno +
                    "\t" +
                    r.connectedGno), "");
        clipboard.toClipboard(text);
    };
    return (React.createElement(Elements.FlexContainerRowWithPadding, null,
        React.createElement("div", null,
            React.createElement(Elements.StandardButton, { onClick: copyCallback }, "Copy")),
        React.createElement(Exporter.XlsxSingleSheetExport, { data: resultToFile(results), filename: "mlc-statistics" }, onClick => (React.createElement(Elements.StandardButton, { onClick: () => onClick() }, "Download")))));
}
function ResultTable(props) {
    const { results } = props;
    const itemsPerPage = 25;
    const [state, setState] = React.useState({
        currentPage: 1
    });
    return (React.createElement("div", null,
        React.createElement(pagination_1.PaginationComponent, { currentPage: state.currentPage, itemsPerPage: itemsPerPage, numberOfPages: Math.ceil(results.length / itemsPerPage), onPageChange: pageNumber => {
                setState({
                    currentPage: pageNumber
                });
            }, onRefresh: () => {
                // props.refreshCallback();
            }, totalItems: results.length }),
        React.createElement(Elements.DataPresenterTable, null,
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Status"),
                    React.createElement("th", null, "Date"),
                    React.createElement("th", null, "User"),
                    React.createElement("th", null, "Deleted"),
                    React.createElement("th", null, "Count"),
                    React.createElement("th", null, "Last used"),
                    React.createElement("th", null, "Name"),
                    React.createElement("th", null, "Mno"),
                    React.createElement("th", null, "ConnectedGno"))),
            React.createElement("tbody", null, results
                .slice((state.currentPage - 1) * itemsPerPage, state.currentPage * itemsPerPage)
                .map(r => resultTableRow(r))))));
}
function parseResult(result, locale, genesysNumberPrefixes) {
    return result.user.mlcUsageSearch.results.map(x => {
        var _a;
        return {
            id: x.id,
            date: x.date
                ? DateHelper.getDateString(DateHelper.fromUTC(x.date), locale)
                : "",
            user: x.userName || "",
            deleted: x.isDeleted === null ? "" : String(x.isDeleted),
            count: x.mLCItemsCount.toString(),
            name: x.name || "",
            connectedGno: ((_a = x.connectedGno) === null || _a === void 0 ? void 0 : _a.split(";").filter(x => x.length > 1).map(x => `${genesysNumberPrefixes.genesysNo}${x.trim()}`).join(",")) || "",
            mno: x.mNoString
                ? `${genesysNumberPrefixes.moistureLoadNo}${x.mNoString}`
                : "",
            lastUsed: x.lastUsage
                ? DateHelper.getDateString(DateHelper.fromUTC(x.lastUsage), locale)
                : "",
            status: x.status !== null &&
                x.status !== undefined &&
                typeof x.status === "number"
                ? `${moisture_load_status_1.MoistureLoadStatus[x.status]} (${x.status})`
                : ""
        };
    });
}
function resultTableRow(row) {
    return (React.createElement("tr", { key: row.id },
        React.createElement("td", null, row.status),
        React.createElement("td", null, row.date),
        React.createElement("td", null, row.user),
        React.createElement("td", null, row.deleted),
        React.createElement("td", null, row.count),
        React.createElement("td", null, row.lastUsed),
        React.createElement("td", null, row.name),
        React.createElement("td", null, row.mno),
        React.createElement("td", null, row.connectedGno)));
}
function resultToFile(results) {
    return [
        [
            "Status",
            "Date",
            "User",
            "Deleted",
            "Count",
            "Last used",
            "Name",
            "MNo",
            "Connected"
        ]
    ].concat(results.map(r => [
        r.status,
        r.date,
        r.user,
        r.deleted,
        r.count,
        r.lastUsed,
        r.name,
        r.mno,
        r.connectedGno
    ]));
}
//# sourceMappingURL=result-container-component.js.map